import Api from "../../api/Api";
import { toast } from "react-toastify";
import {
  GET_APPLESMSFIX_SUCCESS,
  UPDATE_APPLESMSFIX_SUCCESS,
} from "./actionTypes";

const getListParams = (params, state) => ({
  page: params.page ?? state?.pagination?.page ?? 1,
  per_page: params.per_page ?? state?.pagination?.per_page ?? 10,
  search: params.search ?? state?.pagination?.search ?? "",
  silent: params.silent ?? false,
});

const getResponseBody = (response) => response?.data ?? response;

const toList = (value) => (Array.isArray(value) ? value : []);

const buildSuccessPayload = (response, { search }) => {
  const data = getResponseBody(response);
  const items = toList(data.data);

  return {
    applesmsfix: items,
    total: data.total ?? items.length,
    page: data.page ?? 1,
    per_page: data.per_page ?? 10,
    search,
  };
};

const reloadAppleSMSFixList = (dispatch, getState, overrides = {}) => {
  const { pagination } = getState().APPLESMSFIX;
  dispatch(
    loadAppleSMSFix({
      page: pagination?.page ?? 1,
      per_page: pagination?.per_page ?? 10,
      search: pagination?.search ?? "",
      silent: true,
      ...overrides,
    })
  );
};

export const loadAppleSMSFix = (params = {}) => (dispatch, getState) => {
  const listState = getState().APPLESMSFIX;
  const { page, per_page, search, silent } = getListParams(params, listState);

  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;

  const req = Api.get("/applesmsfixall/get", {
    params: { page, per_page, search },
  });

  const onSuccess = (data) => {
    dispatch({
      payload: buildSuccessPayload(data, { search }),
      type: GET_APPLESMSFIX_SUCCESS,
    });
  };

  if (silent) {
    req.then((response) => onSuccess(response)).catch(() => {});
    return;
  }

  toast.promise(req, {
    pending: "Getting Apple SMS Fix IDs...",
    success: {
      render({ data: response }) {
        onSuccess(response);
        return "Your Data Is Ready";
      },
    },
    error: {
      render() {
        return "An error occurred while getting Apple SMS Fix IDs";
      },
    },
  });
};

export const addAppleSMSFix = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesmsfix/add", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleSMSFixList(dispatch, getState, { page: 1 });
        return "Apple SMS Fix ID added successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};

export const updateAppleSMSFix = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesmsfix/update", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: UPDATE_APPLESMSFIX_SUCCESS,
        });
        reloadAppleSMSFixList(dispatch, getState);
        return "Apple SMS Fix ID updated successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while updating your Apple SMS Fix ID";
      },
    },
  });
};

export const deleteAppleSMSFix = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesmsfix/delete", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleSMSFixList(dispatch, getState);
        return "Apple SMS Fix ID deleted successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while deleting your Apple SMS Fix ID";
      },
    },
  });
};

export const importAppleSMSFix = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  Api.defaults.headers.common["Content-Type"] = "multipart/form-data";
  let req = Api.post("/applesmsfix/import", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleSMSFixList(dispatch, getState, { page: 1, search: "" });
        return "Apple SMS Fix IDs imported successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};
